export default class ProspectSourceCategoryDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
}
